<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0"> Dashboard de Inscripciones</h3>
    <p class="text-center text-primary"> <small>Inscripciones por sede.</small> </p>

     <Sedes :model="sede" :tosedes="sedes" style="display:none"/>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Seleccione una Gestion: </div>
            <Gestiones :model="gestion" :default="gestion.gestion"/>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm">
            <div class="input-group-addon"> Unidad de negocio: </div>
            <select class="form-control form-control-sm" v-model="unidad">
              <option v-for="(u,ind) in unidades" :key="ind" :value="u"> {{u}} </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <button class="btn btn-sm btn-link" @click="cambiar()"> <span class="glyphicon glyphicon-signal"></span> Cambiar Grafico</button>

    <div class="row">
      <div class="col-sm-9">
        <canvas id="planet-chart"></canvas>
      </div>

      <div class="col-sm-3">
        <p v-if="datos.length>0" class="text-center text-success">Inscripciones:</p>
        <div v-bind:key="ind" v-for="(i,ind) in datos" style="font-size:12px;margin-bottom:12px">
          <p class="text-primary" style="margin-bottom:0"> <b>Esam {{i.sede}}:</b> </p>
          <b style="margin-left:28px">Dip:</b> <span>{{ i.dip }}, </span> 
          <b>Esp:</b> <span>{{ i.esp }}, </span> 
          <b>Msc:</b> <span>{{ i.mae }}</span>
        </div>
      </div>
    </div>

    <Alertas ref="alertar" />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import {parseJsonError} from '@/components/Utils.js'
import Sedes from '@/components/ASedes'
import Gestiones from '@/components/AGestiones'
import Alertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'
import Chart from 'chart.js';
export default {
  data(){
    return{
      sede: {idsede:null},
      gestion: {gestion:{gestion:null}},
      semaforo: {idsemaforo:{}},
      sedes:{sedes:[]},
      semaforos: [],
      loading: false,
      datos: [],
      labeles: [],
      labeles2: [],
      diplomados: [],
      especialidades: [],
      maestrias: [],
      char: null,
      unidades: ['Esam','Cca','CiberKids'],
      unidad: null,

      planetChartData: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Diplomados',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            },
            {
              label: 'Especialidades',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            },
            {
              label: 'Maestrias',
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 3
            }
          ]
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                padding: 25,
              }
            }]
          }
        }
      }


    }
  },
  components:{ Sedes,Gestiones,Alertas },
  watch:{
    'gestion.gestion':function(){
      this.listener();
    },
    'sedes.sedes':{
      deep:true,
      handler(){
        this.listener();
      }
    },
    'unidad':{
      deep:true,
      handler(){
        this.listener();
      }
    }
  },
  methods:{
    listener(){
      window.console.log( 'UNIDAD:',this.unidad );
      if( this.loading ) return;
      this.loading = true;
      const vue = this;
      if( !this.unidad ) {this.unidad = this.unidades[0]}
      var allsedes = this.sedes.sedes;
      if( allsedes.length == 0 || this.gestion.gestion == null ) return;
      allsedes = allsedes.filter(function(e){ return e.nombre.includes(vue.unidad) });
      var sql = 'query{';
      this.labeles = [];
      this.labeles2 = [];
      allsedes.forEach( function(e){
        var n = e.nombre;
        var se = e.nombre;
        se = se.replace("Esam","");
        se = se.replace("ESAM","");
        if( !n.includes('Formac')){
          n = n.replace(' ','_').toLowerCase();
          n = n.replace(' ','_');
          n = n.replace('í','i')
          sql += n+':getProgramas(idsede:'+e.id+',gestion:'+vue.gestion.gestion.gestion+'){inscripciones{id},postgrado{categoria{nombre}}} ';
          vue.labeles.push( se );
          vue.labeles2.push( n );
        }
      });
      sql += `}`;
      if( allsedes.length == 0 ){
        if( this.char ){
          this.char.reset();
          this.char.destroy();
        }
        return;
      }
      //window.console.log( 'kkkkkkkkkkk',sql);
      sql = gql`${sql}`;
      //window.console.log( 'kkkkkkkkkkk',sql);
      this.getInscripciones( sql );
    },
    cambiar(){
      if( this.planetChartData.type == "bar" ) this.planetChartData.type = "line";
      else this.planetChartData.type = "bar";
      this.createChart( 'planet-chart',this.planetChartData )
    },

    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      if( this.char ){
        this.char.reset();
        this.char.destroy();
      }

      this.char = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
      this.$refs.alertar.reset();
    },
    async getInscripciones( sql ){
      this.$refs.alertar.cargando();
      var vue = this;
      await this.$apollo.query({
        query: sql,
        }).then((data) => {
          var lista = data.data;
          this.datos = [];
          this.diplomados = [];
          this.especialidades = [];
          this.maestrias = [];
          var cd = []; var bd = [];
          var ce = []; var be = [];
          var cm = []; var bm = [];
          this.labeles2.forEach(function(e,i){
            var d = 0;
            var x = 0;
            var m = 0;
            var otros = 0;
            cd.push( '#1976d2' );
            ce.push( '#f9a825' );
            cm.push( '#2e7d32' );
            bd.push( '#004ba0' );
            be.push( '#c17900' );
            bm.push( '#005005' );

            lista[e].forEach( function(f){
              if( f.postgrado.categoria.nombre.includes('Diplomado') ) d += f.inscripciones.length;
              else if( f.postgrado.categoria.nombre.includes('Especialidad') ) x += f.inscripciones.length;
              else if( f.postgrado.categoria.nombre.includes('Maestr') ) m += f.inscripciones.length;
              else otros += f.inscripciones.length
            });
            vue.datos.push( {sede:vue.labeles[i],nombre:vue.labeles2[i],dip:d,esp:x,mae:m} );
            vue.diplomados.push(d);
            vue.especialidades.push(x);
            vue.maestrias.push(m);
            window.console.log( 'OTROS:: ',otros )
          });
          /*window.console.log( vue.datos );
          window.console.log( vue.diplomados );
          window.console.log( vue.especialidades );
          window.console.log( vue.maestrias );*/

          vue.planetChartData.data.labels = vue.labeles;
          vue.planetChartData.data.datasets[0].data = vue.diplomados;
          vue.planetChartData.data.datasets[0].backgroundColor = cd;
          vue.planetChartData.data.datasets[0].borderColor = bd;
          vue.planetChartData.data.datasets[1].data = vue.especialidades;
          vue.planetChartData.data.datasets[1].backgroundColor = ce;
          vue.planetChartData.data.datasets[1].borderColor = be;
          vue.planetChartData.data.datasets[2].data = vue.maestrias;
          vue.planetChartData.data.datasets[2].backgroundColor = cm;
          vue.planetChartData.data.datasets[2].borderColor = bm;
          vue.createChart( 'planet-chart',vue.planetChartData )

          vue.loading = false;
          
        }).catch((error) => {
          window.console.error(error)
          vue.loading = false;
          this.$notify( parseJsonError( error,'getInscripcionesByUser' ) )
        })
    },
  },
  mounted(){
    this.gestion.gestion.gestion = new Date().getFullYear();
    this.$refs.alertar.cargando();
    //this.createChart( 'planet-chart',this.planetChartData )
  }
}
</script>